import React, { useState, useEffect } from 'react';
import './PageStyles.css';

const Seguridad = () => {
  const [username, setUsername] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const obtenerPerfilSeguro = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          setMessage('No hay una sesión activa. Por favor, inicia sesión de nuevo.');
          setLoading(false);
          return;
        }

        // Consultamos al endpoint seguro de funcionarios que creamos antes
        const response = await fetch('https://asistencia-betterland.onrender.com/api/mi-perfil', {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        const data = await response.json();

        if (response.ok) {
          setUsername(data.rut); // Guardamos el RUT real obtenido de la BD
        } else {
          setMessage(data.message || 'Error al autenticar perfil.');
        }
      } catch (error) {
        console.error('Error al cargar perfil:', error);
        setMessage('Error al conectar con el servicio de autenticación.');
      } finally {
        setLoading(false);
      }
    };

    obtenerPerfilSeguro();
  }, []);

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setMessage('');
    setIsSuccess(false);

    if (!username) {
      setMessage('Falta el identificador del usuario.');
      return;
    }

    if (newPassword.length < 6) {
      setMessage('La nueva contraseña debe tener al menos 6 caracteres.');
      return;
    }

    if (newPassword !== confirmPassword) {
      setMessage('Las contraseñas no coinciden.');
      return;
    }

    try {
      const token = localStorage.getItem('token');
      
      const response = await fetch(`https://asistencia-betterland.onrender.com/users/reset-password/${username}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ password: newPassword }),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage('Tu contraseña ha sido actualizada con éxito.');
        setIsSuccess(true);
        setNewPassword('');
        setConfirmPassword('');
      } else {
        setMessage(data.message || 'Error al cambiar la contraseña.');
      }
    } catch (error) {
      setMessage('Error al conectar con el servidor.');
    }
  };

  if (loading) {
    return <div style={{ textAlign: 'center', marginTop: '50px' }}>Validando identidad segura...</div>;
  }

  return (
    <div className="cargausuarios-page-content">
      <h2 className="cargausuarios-page-title">Configuración de Seguridad</h2>

      <div className="cargausuarios-row-of-cards" style={{ justifyContent: 'center' }}>
        <div className="cargausuarios-card" style={{ maxWidth: '450px', width: '100%' }}>
          <h3>Cambiar Contraseña</h3>
          <p style={{ fontSize: '0.9rem', color: '#666', marginBottom: '15px' }}>
            Usuario activo: <strong>{username || 'No detectado'}</strong>
          </p>

          <form onSubmit={handleChangePassword} className="cargausuarios-user-form">
            
            <div className="cargausuarios-password-container">
              <input
                type={showPassword ? 'text' : 'password'}
                placeholder="Nueva Contraseña"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="cargausuarios-show-password-button"
              >
                {showPassword ? 'Ocultar' : 'Mostrar'}
              </button>
            </div>

            <input
              type={showPassword ? 'text' : 'password'}
              placeholder="Confirmar Nueva Contraseña"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />

            <button type="submit" className="cargausuarios-create-button" disabled={!username}>
              Actualizar Contraseña
            </button>
          </form>

          {message && (
            <p 
              className="cargausuarios-message" 
              style={{ color: isSuccess ? 'green' : 'red', marginTop: '15px', textAlign: 'center' }}
            >
              {message}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Seguridad;